import IssuuLookupListResultModelBase from '../_generated/modelBases/issuu-lookup-list-result-model-base';

export default class IssuuLookupListResultModel extends IssuuLookupListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
